import { render, staticRenderFns } from "./aleph-hold-detail.vue?vue&type=template&id=312f8b3f&scoped=true&"
import script from "./aleph-hold-detail.vue?vue&type=script&lang=js&"
export * from "./aleph-hold-detail.vue?vue&type=script&lang=js&"
import style0 from "./aleph-hold-detail.vue?vue&type=style&index=0&id=312f8b3f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312f8b3f",
  null
  
)

export default component.exports